import { render } from "./terms_and_conditions_modal.vue?vue&type=template&id=24091201&scoped=true"
import script from "./terms_and_conditions_modal.vue?vue&type=script&lang=js"
export * from "./terms_and_conditions_modal.vue?vue&type=script&lang=js"

import "./terms_and_conditions_modal.vue?vue&type=style&index=0&id=24091201&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24091201"]])

export default __exports__